import InfoBanner from "../errors/components/InfoBanner"
import ErrorBanner from "../errors/components/ErrorBanner"
import WarningBanner from "../errors/components/warningBanner"
import ActionNeededBanner from "../errors/components/ActionNeededBanner"
import SuccessBanner from "../errors/components/successBanner"
import { useSelector } from "react-redux"
import { selectErrorHandler } from "../errors/errorSlice"
import cn from "../../utils/classes"
import { MIN_WIDTH_NAV_CHILDREN, navChildMinWidths } from "./commonStyle"
import { FormattedCard } from "./FormattedCard"

interface FormattedProfileCardProps {
  children: React.ReactNode
  styleOverrides?: string
  hasNav?: boolean
  hasBanners?: boolean
  fixedMinWidth?: MIN_WIDTH_NAV_CHILDREN
}
export const FormattedProfileCard: React.FC<FormattedProfileCardProps> = ({
  children,
  styleOverrides,
  hasNav,
  hasBanners = true,
  fixedMinWidth,
}) => {
  const errorState = useSelector(selectErrorHandler)
  const anyBannerShowing =
    errorState.infoBanner.isVisible ||
    errorState.errorBanner.isVisible ||
    errorState.warningBanner.isVisible ||
    errorState.actionNeededBanner.isVisible ||
    errorState.successBanner.isVisible
  const minWidthStyle: React.CSSProperties | undefined = fixedMinWidth
    ? { minWidth: `${navChildMinWidths[fixedMinWidth]}px` }
    : undefined
  return (
    <FormattedCard
      styleOverrides={cn(styleOverrides, "relative formatted-profile-card", {
        "!pt-[64px]": anyBannerShowing,
      })}
      hasNav={hasNav}
      style={minWidthStyle}
    >
      {hasBanners && (
        <div className="absolute top-0 left-0 w-full [&>*]:mb-4">
          <InfoBanner />
          <ErrorBanner />
          <WarningBanner />
          <ActionNeededBanner />
          <SuccessBanner />
        </div>
      )}
      {children}
    </FormattedCard>
  )
}
